export const polaroidDefaultMoldura = {
  descricao: "Descrição padrão",
  url: "https://firebasestorage.googleapis.com/v0/b/photonow-app.appspot.com/o/system%2Fphotonow_polaroid.png?alt=media&token=26f1e34a-ae8d-40b5-9181-b74e384644ed",
};
